import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Modal } from 'react-bootstrap'
import {
  CRUDLayout,
  InputSearch,
  CreateButton,
  TdFixed,
  DataStatus,
  Tr,
  ReadButton,
  Alert,
  Pagination,
  Th,
  Td,
  THead,
  TBody,
  ThFixed,
  ReadModal,
} from "components";
import { PageNumber, DateConvert } from "utilities";
import { TransferBahanJobMixApi } from "api";

const TransferBahanJobMix = ({ setNavbarTitle }) => {
  // USE HISTORY
  const history = useHistory();
  const location = useLocation();

  // indikator pemanggilan data sedang dimuat di server (loading)
  const [isLoading, setIsLoading] = useState(false);

  // menampung value dari search form
  const [isSearching, setIsSearching] = useState(false);

  // data jenis
  const [data, setData] = useState([{}]);
  const [processedData, setProcessedData] = useState({});
  const [detailModalConfig, setDetailModalConfig] = useState({ show: false });

  const [paginationConfig, setPaginationConfig] = useState({
    page: "1",
    dataLength: "10",
    totalPage: "1",
    dataCount: "0",
  });
  const [searchConfig, setSearchConfig] = useState({
    status: false,
    key: "",
  });
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: "primary",
    text: "",
  });

  // request data dari server
  const getData = () => {
    setIsLoading(true);
    setIsSearching(false);

    TransferBahanJobMixApi.get({
      q: searchConfig.key,
      page: paginationConfig.page,
      per_page: paginationConfig.dataLength,
    })
      .then((res) => {
        console.log('res', res)
        setData(res?.data?.data ?? [{}]);
        setPaginationConfig({
          ...paginationConfig,
          dataCount: res.data.data_count,
          totalPage: res.data.total_page,
        });
      })
      .catch((err) =>
        setAlertConfig({
          show: true,
          variant: "danger",
          text: "Data gagal dimuat!",
        })
      )
      .finally(() => setIsLoading(false));
  };

  const checkAlert = () => {
    const locationState = location.state;

    if (locationState) {
      if (locationState.alert) {
        setAlertConfig({
          show: locationState.alert.show,
          text: locationState.alert.text,
          variant: locationState.alert.variant,
        });
      }
    }
  };

  const onInputSearchChange = (e) => {
    const key = e.target.value;

    setSearchConfig({
      ...searchConfig,
      key: e.target.value,
    });
    setPaginationConfig({
      page: "1",
      dataLength: "10",
      totalPage: "1",
      dataCount: "0",
    });
    setAlertConfig({
      show: key ? true : false,
      variant: "primary",
      text: "Hasil dari pencarian: " + key,
    });
  };

  useEffect(() => {
    setNavbarTitle("Transfer Bahan Job Mix");
    getData();
    checkAlert();

    return () => {
      setIsLoading(false);
      setIsSearching(false);
    };
  }, [setNavbarTitle, searchConfig.key, paginationConfig.page, paginationConfig.dataLength]);

  // Tabel
  const Table = () => {
    return (
      <>
        <CRUDLayout.Table>
          <THead>
            <Tr>
              <ThFixed>No</ThFixed>
              <ThFixed>Aksi</ThFixed>
              <ThFixed>Tgl. Transfer Bahan</ThFixed>
              <ThFixed>No. Transfer Bahan</ThFixed>
              <Th>No. Permintaan Job Mix</Th>
              <Th>Item Bahan</Th>
              <ThFixed>Qty. Transfer Bahan</ThFixed>
              <Th>Gudang Asal</Th>
              <Th>Gudang Tujuan</Th>
              <Th>Pabrik</Th>
            </Tr>
          </THead>
          <TBody>
            {data.map((val, index) => (
              <Tr key={index}>
                <TdFixed>{PageNumber(paginationConfig.page, paginationConfig.dataLength, index)}</TdFixed>
                <TdFixed>
                  <div className="d-flex flex-row">
                    <ReadButton onClick={() => {
                      setProcessedData(val);
                      setDetailModalConfig({ show: true });
                    }} />
                  </div>
                </TdFixed>
                <Td>{val.tgl_jobmix_transfer_bahan ? DateConvert(new Date(val.tgl_jobmix_transfer_bahan)).defaultDMY : "-"}</Td>
                <Td>{val?.no_jobmix_transfer_bahan ?? "-"}</Td>
                <Td>{val?.no_jobmix_permintaan ?? "-"}</Td>
                <Td>{`${val?.kode_item ? `(${val.kode_item}) ` : ''}${val.nama_item ?? '-'}`}</Td>
                <Td className="text-right">{`${val?.qty_transfer?.replace(".", ",") ?? 0} ${val?.kode_satuan ?? ""}`}</Td>
                <Td>{val?.nama_gudang_asal ?? "-"}</Td>
                <Td>{val?.nama_gudang_tujuan ?? "-"}</Td>
                <Td>{val?.nama_pabrik ?? "-"}</Td>
              </Tr>
            ))}
          </TBody>
        </CRUDLayout.Table>
        {!isSearching && (
          <Pagination
            dataLength={paginationConfig.dataLength}
            dataNumber={paginationConfig.page * paginationConfig.dataLength - paginationConfig.dataLength + 1}
            dataPage={
              paginationConfig.dataCount < paginationConfig.dataLength
                ? paginationConfig.dataCount
                : paginationConfig.page * paginationConfig.dataLength
            }
            dataCount={paginationConfig.dataCount}
            currentPage={paginationConfig.page}
            totalPage={paginationConfig.totalPage}
            onPaginationChange={({ selected }) =>
              setPaginationConfig({
                ...paginationConfig,
                page: selected + 1,
              })
            }
            onDataLengthChange={(e) =>
              setPaginationConfig({
                ...paginationConfig,
                page: 1,
                dataLength: e.target.value,
              })
            }
          />
        )}
      </>
    );
  };

  // Modal Detail
  const DetailModal = () => {
    const ShowData = ({ title, text, line }) => (
      <div>
        <small className="text-secondary" style={{ opacity: 0.8, textTransform: "capitalize" }}>
          {title}
        </small>
        <div className="text-dark">
          <small>{text ? text : "-"}</small>
        </div>
        {line && <hr className="my-2" />}
      </div>
    );

    return (
      <ReadModal size="md" show={detailModalConfig.show} onHide={() => setDetailModalConfig({ show: false })} title="Transfer Bahan Job Mix">
        <Modal.Body>
          <ShowData
            title="Tgl. Transfer Bahan"
            line={true}
            text={
              processedData.tgl_jobmix_transfer_bahan ? DateConvert(new Date(processedData.tgl_jobmix_transfer_bahan)).detail : "-"
            }
          />
          <ShowData
            title="No. Transfer Bahan"
            line={true}
            text={processedData.no_jobmix_transfer_bahan ?? "-"}
          />
          <ShowData
            title="No. Permintaan Job Mix"
            line={true}
            text={processedData.no_jobmix_permintaan ?? "-"}
          />
          <ShowData
            title="Item Bahan"
            line={true}
            text={`${processedData.kode_item ? `(${processedData.kode_item}) ` : ''}${processedData.nama_item ?? '-'}`}
          />
          <ShowData
            title="Qty. Transfer Bahan"
            line={true}
            text={`${processedData.qty_transfer?.replace(".", ",") ?? 0} ${processedData.kode_satuan ?? ""}`}
          />
          <ShowData
            title="Gudang Asal"
            line={true}
            text={processedData.nama_gudang_asal ?? "-"}
          />
          <ShowData
            title="Gudang Tujuan"
            line={true}
            text={processedData.nama_gudang_tujuan ?? "-"}
          />
          <ShowData
            title="Pabrik"
            line={true}
            text={processedData.nama_pabrik ?? "-"}
          />
        </Modal.Body>
      </ReadModal >
    );
  };

  return (
    <CRUDLayout>
      <CRUDLayout.Head>
        <CRUDLayout.HeadSearchSection>
          <div className="d-flex mb-3">
            <InputSearch value={searchConfig.key} onChange={onInputSearchChange} />
          </div>
        </CRUDLayout.HeadSearchSection>

        <CRUDLayout.HeadButtonSection>
          {/* <ExportButton /> */}
          <CreateButton
            onClick={() => {
              history.push(
                "/inventory/transaksi/transfer-bahan-job-mix/list-permintaan-bahan"
              );
            }}
          />
        </CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      {/* ALert */}
      <Alert
        show={alertConfig.show}
        variant={alertConfig.variant}
        text={alertConfig.text}
        showCloseButton={true}
        onClose={() => {
          setAlertConfig({
            ...alertConfig,
            show: false,
          });
          // CLEAR HISTORY LOCATION
          history.replace("/inventory/transaksi/transfer-bahan-job-mix", {
            registerAlertConfig: undefined,
          });
        }}
      />

      {/* Table Section */}
      {isLoading
        ? <DataStatus loading={true} text="Memuat data..." />
        : data.length ? <Table /> : <DataStatus text="Tidak ada data" />
      }
      {detailModalConfig.show && <DetailModal />}
    </CRUDLayout>
  );
};

export default TransferBahanJobMix;
